import * as React from 'react';
import { EmptyFiltersScreen } from '@/components/common';
interface Props {
	className?: string;
}

export const EmptyStateSearch: React.FC<Props> = ({ className }) => {
	return (
		<EmptyFiltersScreen className={`h-[65%] ${className}`}>
			<>
				No results were found for your search.
				<br />
				<br />
				Please try using different keywords.
			</>
		</EmptyFiltersScreen>
	);
};
